export const OC_PRODUCT_DETAILS_PAGE = {
  desktop: `
<div class="cui cui-grid cui-container">

  <div class="display-none display-md-block cui-skeleton-paragraph -size--small -resolution--desktop -spacing--top-40 -spacing--bottom-64">
    <div class="cui-skeleton-paragraph__content" style="width: 405px;">
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>

  <div class="display-sm-block display-md-none cui-skeleton-paragraph -size--small -resolution--desktop -spacing--top-24 -spacing--bottom-40" style="max-width: 100%;">
    <div class="cui-skeleton-paragraph__content" style="width: s405px; max-width: 100%;">
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>

  <div class="display-none display-md-block display-lg-none cui-skeleton-heading -size--large -resolution--desktop -spacing--bottom-32">
    <div class="cui-skeleton-heading__content -spacing--bottom-24" style="width:max(300px, 100%)">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
    <div class="cui-skeleton-rectangle -is--block">
      <div class="cui-skeleton__item" style="width: 187px; height: 28px;"></div>
    </div>
  </div>

  <div class="display-sm-block display-md-none cui-skeleton-heading -size--medium -resolution--desktop -spacing--bottom-24">
    <div class="cui-skeleton-heading__content -spacing--bottom-24" style="width:max(300px, 100%)">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
    <div class="cui-skeleton-rectangle -is--block">
      <div class="cui-skeleton__item" style="width: 187px; height: 28px;"></div>
    </div>
  </div>

  <div class="cui-row">

    <div class="cui-col-lg-6 cui-skeleton-rectangle -is--block">
      <div class="cui-skeleton__item" style="width: 100%; height: 360px;"></div>
      <div class="-spacing--bottom-32 display-none display-md-block" style="width: 100%;"></div>
      <div class="-spacing--bottom-24 display-sm-block display-md-none" style="width: 100%;"></div>
    </div>

    <div class="cui-col-lg-6">
      <div class="display-none display-lg-block">
        <div class="cui-skeleton-heading -size--large -resolution--desktop -spacing--bottom-24">
          <div class="cui-skeleton-heading__content" style="width:max(300px, 100%)">
            <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>

        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-32">
          <div class="cui-skeleton__item" style="width: 187px; height: 28px;"></div>
        </div>
      </div>

      <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-24">
        <div class="cui-skeleton-paragraph__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>

      <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-8">
        <div class="cui-skeleton-paragraph__content" style="width: 120px;">
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-rectangle -spacing--bottom-24">
        <div class="cui-skeleton__item" style="width: 88px; height: 40px; margin-right: 12px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -spacing--bottom-24">
          <div class="cui-skeleton__item" style="width: 88px; height: 40px;"></div>
      </div>

      <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-8">
        <div class="cui-skeleton-paragraph__content" style="width: 120px;">
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-rectangle -spacing--bottom-24">
        <div class="cui-skeleton__item" style="width: 88px; height: 40px; margin-right: 12px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -spacing--bottom-24">
          <div class="cui-skeleton__item" style="width: 88px; height: 40px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-24">
        <div class="cui-skeleton__item" style="width: 100%; height: 236px;"></div>
      </div>

    </div>
  </div>

</div>

<div class="cui-skeleton-rectangle -is--block">
  <div class="cui-skeleton__item" style="width: 100%; height: 56px;"></div>
</div>

<div class="cui cui-grid cui-container">
  <div class="-spacing--bottom-64 display-none display-md-block" style="width: 100%;"></div>
  <div class="-spacing--bottom-24 display-sm-block display-md-none" style="width: 100%;"></div>

  <div class="cui-skeleton-heading -size--medium -resolution--desktop -spacing--bottom-16">
    <div class="cui-skeleton-heading__content" style="width:max(300px, 100%)">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
    </div>
  </div>

  <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-8 cui-col-lg-7">
    <div class="cui-skeleton-paragraph__content" style="width: 100%;">
      <div class="cui-skeleton__item cui-skeleton__description"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div class="-spacing--bottom-64 display-none display-md-block" style="width: 100%;"></div>
  <div class="-spacing--bottom-24 display-sm-block display-md-none" style="width: 100%;"></div>

  <div class="cui-skeleton-rectangle -is--block">
    <div class="cui-skeleton__item" style="width: 300px; height: 32px;"></div>
  </div>
  <div class="-spacing--bottom-32 display-none display-md-block" style="width: 100%;"></div>
  <div class="-spacing--bottom-24 display-sm-block display-md-none" style="width: 100%;"></div>

  <div class="cui-skeleton-rectangle -is--block">
    <div class="cui-skeleton__item" style="width: 540px; height:48px; max-width: 100%"></div>
  </div>
  <div class="-spacing--bottom-32 display-none display-md-block" style="width: 100%;"></div>
  <div class="-spacing--bottom-24 display-sm-block display-md-none" style="width: 100%;"></div>

  <div class="cui-skeleton-paragraph -size--small -resolution--desktop -spacing--bottom-24">
    <div class="cui-skeleton-paragraph__content" style="width: 120px;">
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>

  <div class="display-none display-lg-block -spacing--bottom-64">
    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4">
      <div class="cui-skeleton__item" style="width: 100%; height:52px;"></div>
    </div>
    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4">
      <div class="cui-skeleton__item" style="width: 100%; height:60px;"></div>
    </div>
    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4">
      <div class="cui-skeleton__item" style="width: 100%; height:60px;"></div>
    </div>
    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4">
      <div class="cui-skeleton__item" style="width: 100%; height:60px;"></div>
    </div>
    <div class="cui-skeleton-rectangle -is--block -spacing--bottom-4">
      <div class="cui-skeleton__item" style="width: 100%; height:60px;"></div>
    </div>
    <div class="cui-skeleton-rectangle -is--block">
      <div class="cui-skeleton__item" style="width: 100%; height:60px;"></div>
    </div>
  </div>

  <div class="display-sm-block display-lg-none display-lg-none">
    <div class="cui-row">
      <div class="cui-col-md-4 cui-col-sm-4 cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height:180px;"></div>
      </div>
      <div class="cui-col-md-4 cui-col-sm-4 cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height:180px;"></div>
      </div>
    </div>
    <div class="-spacing--bottom-8 display-none display-md-block display-lg-none" style="width: 100%;"></div>

    <div class="cui-row">
      <div class="cui-col-md-4 cui-col-sm-4 cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height:180px;"></div>
      </div>
      <div class="cui-col-md-4 cui-col-sm-4 cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height:180px;"></div>
      </div>
    </div>
    <div class="-spacing--bottom-8 display-none display-md-block display-lg-none" style="width: 100%;"></div>

    <div class="cui-row">
      <div class="cui-col-md-4 cui-col-sm-4 cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height:180px;"></div>
      </div>
      <div class="cui-col-md-4 cui-col-sm-4 cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height:180px;"></div>
      </div>
    </div>
  </div>
  <div class="-spacing--bottom-64 display-none display-md-block" style="width: 100%;"></div>
  <div class="-spacing--bottom-40 display-sm-block display-md-none" style="width: 100%;"></div>

  <div class="cui-skeleton-heading -size--medium -resolution--desktop">
    <div class="cui-skeleton-heading__content" style="width:max(300px, 100%)">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
    </div>
  </div>
  <div class="-spacing--bottom-32 display-none display-md-block" style="width: 100%;"></div>
  <div class="-spacing--bottom-24 display-sm-block display-md-none" style="width: 100%;"></div>

  <div class="cui-row">
    <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-4 cui-skeleton-rectangle -is--block -spacing--bottom-24">
      <div class="cui-skeleton__item" style="width: 100%; height:152px;"></div>
    </div>
    <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-4 cui-skeleton-rectangle -is--block -spacing--bottom-24">
      <div class="cui-skeleton__item" style="width: 100%; height:152px;"></div>
    </div>
    <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-4 cui-skeleton-rectangle -is--block -spacing--bottom-24">
      <div class="cui-skeleton__item" style="width: 100%; height:152px;"></div>
    </div>
    <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-4 cui-skeleton-rectangle -is--block -spacing--bottom-24">
      <div class="cui-skeleton__item" style="width: 100%; height:152px;"></div>
    </div>
  </div>

</div>`
};
